import React, { useEffect, useState } from "react"
import { useConsent, useConsentGranted } from "./useConsent"

import "./ConsentBanner.scss"

const ConsentBanner: React.FC = () => {
  const { bannerOpen, closeBanner, acceptAll, saveCategories, state } = useConsent()
  const granted = useConsentGranted()

  // When reopened after a decision, prefill from stored record. When first-run,
  // both categories are OFF as required by Cal. Penal Code § 638.51(a).
  const [analytics, setAnalytics] = useState(false)
  const [marketing, setMarketing] = useState(false)
  const [customizing, setCustomizing] = useState(false)

  useEffect(() => {
    if (bannerOpen) {
      setAnalytics(granted.analytics)
      setMarketing(granted.marketing)
      setCustomizing(state.status === "decided")
    }
  }, [bannerOpen, granted.analytics, granted.marketing, state.status])

  if (!bannerOpen) return null

  const isRevisit = state.status === "decided"

  return (
    <div className="consent-banner" role="dialog" aria-modal="false" aria-labelledby="consent-banner-title">
      <div className="consent-banner__inner">
        <div className="consent-banner__copy">
          <h2 id="consent-banner-title" className="consent-banner__title">
            Cookies
          </h2>
          <p className="consent-banner__body">
            Activeloop uses cookies for analytics and marketing, only with your permission.{" "}
            <a href="https://activeloop.ai/privacy/" target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
            .
          </p>
        </div>

        {customizing && (
          <fieldset className="consent-banner__categories">
            <legend className="sr-only">Choose which cookie categories to allow</legend>

            <label className="consent-banner__category">
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
              />
              <span>
                <strong>Analytics</strong>
                <span className="consent-banner__category-hint">
                  Google Analytics and Statsig product analytics.
                </span>
              </span>
            </label>

            <label className="consent-banner__category">
              <input
                type="checkbox"
                checked={marketing}
                onChange={(e) => setMarketing(e.target.checked)}
              />
              <span>
                <strong>Marketing and session replay</strong>
                <span className="consent-banner__category-hint">
                  GTM, Segment, Statsig Session Replay, and downstream ad / attribution tools.
                </span>
              </span>
            </label>
          </fieldset>
        )}

        <div className="consent-banner__actions">
          {customizing ? (
            <button
              type="button"
              className="consent-banner__btn consent-banner__btn--primary"
              onClick={() => saveCategories({ analytics, marketing })}
            >
              Save choices
            </button>
          ) : (
            <button
              type="button"
              className="consent-banner__btn consent-banner__btn--primary"
              onClick={acceptAll}
            >
              Accept all
            </button>
          )}
          {!customizing && (
            <button
              type="button"
              className="consent-banner__btn consent-banner__btn--ghost"
              onClick={() => setCustomizing(true)}
            >
              Customize
            </button>
          )}
          <button
            type="button"
            className="consent-banner__btn consent-banner__btn--link"
            onClick={closeBanner}
          >
            Dismiss
          </button>
          {isRevisit && (
            <button
              type="button"
              className="consent-banner__btn consent-banner__btn--link"
              onClick={closeBanner}
              aria-label="Close without changing"
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default ConsentBanner
